import React from 'react'
import { Global, css } from '@emotion/react'

import Header from './components/Header'
import Main from './components/Main'
import Footer from './components/Footer'
import Base from './Base'
import tinycolor from 'tinycolor2'

// Component
const Template2 = (props) => {
  const accentColor = props.invoiceSettings.accentColor

  return (
    <Base {...props}>
      <Global
        styles={css`
          .invoice-table {
            thead tr {
              background: none;
              th {
                border-bottom: 1px solid rgba(44, 53, 77, 0.12);
                padding-top: 0px;
              }
            }
            thead tr th,
            .subtotal-amount td div,
            .total-amount td div {
              border-width: 2px !important;
            }
          }

          .invoice-number.title,
          .invoice-table .total-amount {
            color: ${props.invoiceSettings.accentColor};
          }
          .invoice-number.title {
            font-weight: 600;
            margin-bottom: 1.4rem;
          }
          .invoice-information {
            position: relative;
          }
          .invoice-information:after {
            background: ${tinycolor(accentColor).setAlpha(0.03).toRgbString()};
            position: absolute;
            top: -29.7cm;
            left: -0.55in;
            right: -0.55in;
            bottom: 0;
            content: ' ';
            z-index: -1;
          }
          .invoice-information .invoice-information-content .invoice-details {
            background: none;
            padding: 0 !important;
            margin-bottom: 0px;
          }
          .invoice-information {
            padding-bottom: 2.4rem;
          }
        `}
      />
      <Header {...props} />
      <Main {...props} />
      <div className={'background'}></div>

      <Footer {...props} />
    </Base>
  )
}

export default Template2
